import React, { Component } from 'react'
import { Element } from 'react-scroll'
import { withTranslation } from 'react-i18next'

import Layout from './Layout'
import Menu from '../Menu'
import Footer from '../Footer'

const PrimaryLayout = ({ children, page, language, isDisplayFromHome }) => {
  return (
    <Layout language={language} page={page}>
      <Menu variant={isDisplayFromHome ? 'primary' : 'secondary'} page={page} />
      <div style={{ overflowX: 'hidden' }}>{children}</div>

      <Footer isDisplayFromHome={isDisplayFromHome} />
    </Layout>
  )
}

export default PrimaryLayout
